import React, { useState } from 'react';
import type { ButtonCopyTextProps } from '@components/atoms/button-copy-text/types';
import { useCopyToClipboard } from '@hooks/use-copy-to-clipboard';
import { useDebounce } from '@hooks/use-debounce';
import { Tooltip } from '@mui/material';

import { CopyIcon } from '../../icons';

import { Button } from './styles';

export const ButtonCopyText: React.FC<ButtonCopyTextProps> = ({
    copyText,
    className,
    icon,
    tooltipProps,
    onClick,
}) => {
    const [, copy] = useCopyToClipboard();
    const [open, setOpen] = useState(false);

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipCloseDebounce = useDebounce(handleTooltipClose, 2000);

    const handleTooltipOpen = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        setOpen(true);
        handleTooltipCloseDebounce();
        onClick?.(e);
    };

    return (
        <Tooltip
            PopperProps={{
                disablePortal: true,
            }}
            onClose={handleTooltipClose}
            open={open}
            disableFocusListener={true}
            disableHoverListener={true}
            disableTouchListener={true}
            {...tooltipProps}
        >
            <Button
                className={className}
                onClick={(e) => {
                    copy(copyText);
                    handleTooltipOpen(e);
                }}
            >
                {icon || <CopyIcon />}
            </Button>
        </Tooltip>
    );
};
